import React from 'react';

import * as ContentList from '@/components/ContentList';

import { UseLearnerAndGroupList } from '../../hooks/useLearnerAndGroupList';
import LearnerListItem from '../ListItem';
import { ListItemProps } from '../ListItem/types';

interface LearnerContentListProps {
  learnerListItems: UseLearnerAndGroupList['learnerListItems'];
  disabled?: boolean;
  onRemoveUser: UseLearnerAndGroupList['onRemoveUser'];
  label?: ListItemProps['label'];
  pillRenderer?: (userId: string) => JSX.Element;
  hideRemoveButton?: boolean;
  disableHoverStyle?: boolean;
  className?: string;
  disabledRemoveIds?: string[];
}

const LearnerContentList: React.FC<LearnerContentListProps> = ({
  learnerListItems,
  disabled,
  onRemoveUser,
  hideRemoveButton,
  label,
  pillRenderer,
  className,
  disabledRemoveIds,
  disableHoverStyle,
}) => {
  return (
    <ContentList.Provider items={learnerListItems}>
      <ContentList.Items
        renderer={(index) => {
          const learner = learnerListItems[index];

          return (
            <LearnerListItem
              key={learner.id}
              className={className}
              disableHoverStyle={disableHoverStyle}
              disabled={disabled}
              hideRemoveButton={hideRemoveButton || disabledRemoveIds?.includes(learner.id)}
              label={label}
              pillRenderer={pillRenderer}
              user={learner}
              onRemove={onRemoveUser}
            />
          );
        }}
      />
    </ContentList.Provider>
  );
};

export default LearnerContentList;
